module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAACJSURBVEiJtZbJDcAgDARHqYIS02XKSCEugHycTxRxLYvEC3lGYLABOIEALqCgj5KsSDYB1Jy3KCnJeHlB2iq65Auvyf5dmJV0GYpkOHZFMh0zE7C865FAOW8twI5L0ZRsgbck2+A9yRD8UO3qsB6RNcnWa2p9aNZSYS121nJtbzj2lmlv+tZvywPo/cgVvE04RwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/close.png
// module id = q6r7
// module chunks = 1